import { range } from 'lodash';

import * as OvationsApi from 'core/ovations-api';

export const mockAppeasementAttachments: OvationsApi.Types.AppeasementAttachment[] = range(1, 4).map((i) => ({
    id: i,
    fileLocation: `fileLocation-${i}`,
    fileName: `fileName-${i}`,
    fileUrl: `fileUrl-${i}`,
}));

export default mockAppeasementAttachments;
